export const numberPattern = /^[\d\s,]+$/;
